import sortBy from 'lodash/sortBy'
import { useMemo } from 'react'

import { Review } from './components/Review'
import { ReviewTimelineHeader } from './components/ReviewTimelineHeader'
import { ReviewTimelineLayout } from './components/ReviewTimelineLayout'
import { ReviewTimelineProps } from './ReviewTimeline.types'

export const ReviewTimeline = ({
  aiSummaryBanner,
  bookingURL,
  canReplyReview,
  className,
  guestName,
  isLastReviewOnPage,
  onlyReviewSummary,
  period,
  reviews,
  shouldDisplayHomeName,
  shouldHideDate,
  shouldHideHeader,
  source,
  onGuestNameClick,
  onReplyReview,
  afterRatings,
}: ReviewTimelineProps) => {
  const homeName = shouldDisplayHomeName && reviews.length > 0 ? reviews[0]?.home?.name : undefined

  const sortedReviews = useMemo(() => {
    return sortBy(reviews, 'createdAt')
  }, [reviews])

  return (
    <ReviewTimelineLayout
      shouldHideDate={shouldHideDate}
      className={className}
      items={sortedReviews}
      renderItem={(review, index) => (
        <Review
          isLastReview={reviews.length - 1 === index}
          isLastReviewOnPage={isLastReviewOnPage}
          review={review}
          hideComments={onlyReviewSummary}
          canReplyReview={canReplyReview}
          onReplyReview={onReplyReview}
          afterRatings={afterRatings}
        />
      )}
    >
      {aiSummaryBanner}

      {!shouldHideHeader && (
        <ReviewTimelineHeader
          guestName={guestName}
          period={period}
          source={source}
          bookingURL={bookingURL}
          homeName={homeName}
          onGuestNameClick={onGuestNameClick}
        />
      )}
    </ReviewTimelineLayout>
  )
}

ReviewTimeline.Layout = ReviewTimelineLayout
